import { HttpRequest, HttpHandlerFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { AppConfigService } from '@app/core/config/config.service';

export const apimSubscriptionInterceptor = (httpRequest: HttpRequest<unknown>, next: HttpHandlerFn) => {
  const appConfigService = inject(AppConfigService);
  return next(
    httpRequest.clone({
      setParams: { 'subscription-key': appConfigService?.apimSubscriptionKey },
    })
  );
};
